module.exports = __webpack_public_path__ + "img/item.7dded8f5.png";